// Debugger
import Debugger from "@/config/debugger";
const debug = new Debugger("main.js", true);

/* eslint-disable no-unused-vars */

// auth functions imported as Mixin at Auth.vue and App.vue
import { firebaseApp } from "@/config/firebase"
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
const db = firebase.firestore(firebaseApp);
const userRef = db.collection("users");

export default {
    methods: {
        _signIn(userObj) {
            this.showLoader();
            const _this = this;
            let email = userObj.Email
            let password = userObj.Password

            firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
                debug.log('_signedIn', user)
            }).catch(function (error) {
                // Handle Errors here.
                // var errorCode = error.code;
                // var errorMessage = error.message;
                console.log('error', error)
            });

        },
        _registerUser(userObj) {
            const _this = this;

            firebase.auth().createUserWithEmailAndPassword(userObj.Email, userObj.Password).then((data) => {
                console.log(data.user, data.user.uid)
                // userData returned user data from Firebase
                let userData = data.user;
                // newUserData combines the registration form info contact with returned firebase userData
                // this will be data saved to profile
                let newUserData = {
                    uid: userData.uid,
                    First_Name: userObj.First_Name,
                    Last_Name: userObj.Last_Name,
                    Email: userObj.Email,
                    Terms: false,
                    creationTime: userData.metadata.creationTime,
                    providerData: userData.providerData[0].providerId,
                    Role: _this.defaultRole(),
                }


                _this._addContactToDB(newUserData)

            }).catch(function (error) {
                // Handle Errors here.
                // var errorCode = error.code;
                // var errorMessage = error.message;
                debug.log.log(error)

            });

        },
        _addContactToDB(userObj) {

            const _this = this;
            let successMsg = "Contact has been successfully added"

            if (userObj.uid) {
                successMsg = "Registration Success"
            }

            userRef.add(userObj).then((docRef) => {
                debug.log('_addUser', docRef, userObj)

                _this.appAlert({ color: 'success', message: successMsg })

            }).catch(function (error) {
                // Handle Errors here.
                // var errorCode = error.code;
                // var errorMessage = error.message;
                debug.log('_addNewUserProfile error', error)

            });
        },
        _updateUser() {
            //TODO 
        },
        _getUserData(user) {
            // gets user profile data from database
            const _this = this;
            return new Promise((resolve, reject) => {
                let userData = ""

                userRef.where("uid", "==", user.uid)
                    .get().then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            // doc.data() is never undefined for query doc snapshots
                            userData = doc.data();
                            userData.profileId = doc.id;
                            userData.signedIn = true;
                            _this.$root.user = userData;
                            resolve(userData)
                        });
                    })
                    .catch(function (error) {
                        console.log("Error getting documents: ", error);
                        reject(error)
                    });
            })
        },
        _signOut() {
            const _this = this;
            firebase
                .auth()
                .signOut()
                .then(function () {
                    // Sign-out successful.
                    _this._resetAppUser();
                    console.log("user signedOut");
                })
                .catch(function (error) {
                    console.log("sign-out error", error);
                    // An error happened.
                });
        },
        _resetAppUser() {
            this.$root.user = { signedIn: false };
        },
        _resetPassword(userObj) {
            let email = userObj.Email;
            return new Promise((resolve, reject) => {
                var auth = firebase.auth();
                var emailAddress = email;

                auth.sendPasswordResetEmail(emailAddress).then(function () {
                    // Email sent.
                    resolve('Email Sent')
                }).catch(function (error) {
                    // An error happened.
                    reject(error)
                });
            })
        }
    },
}
/* eslint-enable no-unused-vars */